import { IGradientImage } from '@vfit/shared/models';
import { ImageAtoms } from '@vfit/shared/atoms';
import { IStoryCard } from '../../storyCard.models';
import {
  CardContainerLarge,
  ContentContainerLarge,
  CreatorLarge,
  Ellipse,
  EllipseContainer,
  TitleLarge,
  TopicLarge,
} from '../../storyCard.style';

export const StoryCardLarge = ({
  title,
  topic,
  creator,
  backgroundImg,
  ellipseImg,
  isExternalImages,
  ignoreSize,
  blurredBackgroundImg,
}: Omit<IStoryCard, 'variant'>) => {
  const ellipseSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
      <circle cx="30" cy="30" r="28.75" stroke="white" strokeWidth="1.5" />;
    </svg>
  );

  return (
    <CardContainerLarge ignoreSize={ignoreSize}>
      {backgroundImg && title && (
        <ImageAtoms
          image={backgroundImg}
          nameCard={title}
          placeholder={blurredBackgroundImg ? 'blur' : 'empty'}
          blurDataURL={blurredBackgroundImg}
          objectFit="cover"
          loading="lazy"
          external={isExternalImages}
          gradient={IGradientImage.GRADIENT_TOP_10}
          type="default"
        />
      )}
      <EllipseContainer>
        {ellipseImg && ellipseSvg}
        {ellipseImg && (
          <Ellipse img="#">
            <ImageAtoms
              image={ellipseImg}
              nameCard=""
              objectFit="cover"
              external={isExternalImages}
              style={{
                position: 'relative',
                width: '100%',
                height: '0',
                overflow: 'hidden',
                borderRadius: '48px',
              }}
            />{' '}
          </Ellipse>
        )}
      </EllipseContainer>
      <ContentContainerLarge>
        {topic && <TopicLarge>{topic}</TopicLarge>}
        {title && <TitleLarge>{title}</TitleLarge>}
        {creator && <CreatorLarge>{creator}</CreatorLarge>}
      </ContentContainerLarge>
    </CardContainerLarge>
  );
};
